import { TrustAccount } from '../types/index';

export const TRUST_ACCOUNT_SELECTION_KEY = 'selectedTrustAccountId';
export const TRUST_ACCOUNT_KIND_KEY = 'selectedTrustAccountKind';

export const isSavingsTrustAccount = (account?: TrustAccount | null): boolean => {
  if (!account) return false;

  if (account.accountKind?.toLowerCase() === 'savings') {
    return true;
  }

  return (account.accountName || '').toLowerCase().includes('savings');
};

export const sortTrustAccountsByKind = (accounts: TrustAccount[]): TrustAccount[] => {
  return [...accounts].sort((first, second) => {
    const firstRank = isSavingsTrustAccount(first) ? 1 : 0;
    const secondRank = isSavingsTrustAccount(second) ? 1 : 0;

    if (firstRank !== secondRank) {
      return firstRank - secondRank;
    }

    return first.accountName.localeCompare(second.accountName);
  });
};

export const getSavedTrustAccountId = (): number | null => {
  const raw = localStorage.getItem(TRUST_ACCOUNT_SELECTION_KEY);
  if (!raw) return null;

  const parsed = Number(raw);
  return Number.isFinite(parsed) ? parsed : null;
};

export const saveSelectedTrustAccountId = (id: number, kind?: string) => {
  localStorage.setItem(TRUST_ACCOUNT_SELECTION_KEY, String(id));
  if (kind) {
    localStorage.setItem(TRUST_ACCOUNT_KIND_KEY, kind);
  }
  window.dispatchEvent(new Event('trust-account-changed'));
};
